export default {
  overviewTitle: 'Vergunningen',
  detailTitle: 'Vergunning',
  deleteTitle: 'deze Vergunning',
  url: '/vehicle/licenses',
  apiUrl: '/licenses/',
  sortBy: ['nr'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'vehicle/licenses',
  quickFilter: {
    text: 'Zoek op nr',
    value: 'nr',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Klant', value: 'customer_id', type: 'optionList', optionListName: 'customers', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Vervalt binnen', value: 'expires_in', suffix: 'dag(en)', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'ChassisNr', value: 'chassisnr', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Excl. onder voorbehoud', value: 'not_onhold', type: 'boolean', columns: 1, labelCols: 10, inputCols: 2},
    {text: 'Bestemming', value: 'location', columns: 2, labelCols: 5, inputCols: 7}
    // {text: 'Chauffeur', value: 'driver_id', type: 'optionList', optionListName: 'drivers'},
    // {text: 'Trekker ChassisNr', value: 'truck_chassisnr'},
    // {text: 'Aanhangwagen ChassisNr', value: 'trailer_chassisnr'}
    // {text: 'Periode van', value: 'begin_timestamp_date_ge', type: 'date'},
    // {text: 'Periode tot', value: 'begin_timestamp_date_le', type: 'date'},
    // {text: 'Dossier', value: 'dossier'},
    // {text: 'Niet gefactureerd', value: 'not_invoiced', type: 'boolean'}
  ],
  newRecord: {
    max_length: 0,
    max_width: 0,
    max_height: 0,
    max_weight: 0,
    axle_distance: 0,
    extended: 0,
    trucks: [],
    trailers: []
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Nummer', value: 'nr', link: '/vehicle/licenses/{id}', width: '5%'},
    {text: 'Vervaldatum', value: 'expiry_date', width: '5%', filter: 'date'},
    {text: 'Klant', value: 'customer_name', width: '5%'},
    {text: 'Trekkers', value: 'truck_description', width: '2%'},
    {text: 'Aanhangwagens', value: 'trailer_description', width: '2%'},
    {text: 'Aard Lading', value: 'cargo_type', width: '5%'},
    // {text: 'Aanvraagdatum', value: 'application_date', width: '5%', filter: 'date'},
    {text: 'Lengte (cm)', value: 'max_length', width: '2%'},
    {text: 'Breedte (cm)', value: 'max_width', width: '2%'},
    {text: 'Hoogte (cm)', value: 'max_height', width: '2%'},
    {text: 'Gewicht (ton)', value: 'max_weight', width: '2%'},
    // {text: 'Uitgeschoven', value: 'extended', width: '2%'},
    {text: 'Type', value: 'licensecategory_category', width: '5%'},
    {text: 'Aankomst', value: 'arrival_location', width: '5%'},
    {text: 'Vertrek', value: 'departure_location', width: '5%'},
    {text: 'Bestand', value: 'license_file', type: 'file', width: '5%', align: 'center', sortable: false, access: 'manager'},
    {text: 'Email Klant', value: 'email_customer_timestamp', filter: 'date', width: '6%'}
    // {text: 'Asafstand', value: 'axle_distance', width: '10%'}
  ]
};
